// Dark Theme - Adapted from DESIGN_NOTES.md Light Theme
export const darkTheme = {
  name: 'dark',

  colors: {
    // Background colors
    background: {
      primary: '#1a1a1a', // Main background (cards, modals) - Almost black
      secondary: '#222222', // Page background, slightly lighter
      tertiary: '#2a2a2a', // Alternative background, card elevation
      hover: '#2e2e2e', // Hover state background
      disabled: '#333333', // Disabled elements background
      page: '#1a1a1a' // ContentStyle.Content background
    },

    // Text colors
    text: {
      primary: '#ffffff', // Main text, titles
      secondary: '#e0e0e0', // Body text
      tertiary: '#b0b0b0', // Labels, secondary info
      muted: '#808080', // Placeholder text, disabled text
      disabled: '#666666', // Disabled text
      inverse: '#000000' // Text on light backgrounds
    },

    // Border colors
    border: {
      light: '#2a2a2a', // Card separators, subtle borders
      medium: '#333333', // Input borders, card borders
      strong: '#444444', // Strong borders, active states
      focus: '#00bbfe' // Focus state borders
    },

    // Semantic colors (actions, states)
    semantic: {
      primary: '#00bbfe', // Primary actions (blu logo chiaro)
      success: '#22c55e', // Success actions, add buttons (kept bright for visibility)
      successHover: '#1e3a2b', // Success button hover background (dark green)
      danger: '#EF4444', // Delete, error actions (slightly brighter)
      warning: '#FB923C', // Warning states (brighter)
      info: '#3B82F6', // Info states (brighter)
      secondary: '#9CA3AF' // Secondary actions (lighter gray)
    },

    // Shadow colors
    shadow: {
      light: 'rgba(0, 0, 0, 0.3)', // Card shadow default (darker in dark mode)
      medium: 'rgba(0, 0, 0, 0.5)', // Card shadow hover
      strong: 'rgba(0, 0, 0, 0.7)', // Modal shadow
      overlay: 'rgba(0, 0, 0, 0.7)', // Modal overlay (darker)
      focus: 'rgba(0, 187, 254, 0.25)' // Button focus shadow (light in dark mode)
    },

    // Scrollbar colors
    scrollbar: {
      track: '#222222', // Scrollbar track background
      thumb: '#444444', // Scrollbar thumb
      thumbHover: '#555555', // Scrollbar thumb hover
      thumbActive: '#666666' // Scrollbar thumb active
    },

    // Chart colors (for analytics/charts compatibility)
    primary: {
      main: '#3B82F6',
      light: '#60A5FA',
      dark: '#2563EB'
    },
    success: {
      main: '#22c55e',
      light: '#4ade80',
      dark: '#16a34a'
    },
    danger: {
      main: '#EF4444',
      light: '#F87171',
      dark: '#DC2626'
    },
    warning: {
      main: '#F97316',
      light: '#FB923C',
      dark: '#EA580C'
    },
    info: {
      main: '#3B82F6',
      light: '#60A5FA',
      dark: '#2563EB'
    }
  },

  // Typography (same as light theme)
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: {
      cardTitle: '1rem',
      label: '0.75rem',
      input: '0.875rem',
      button: '0.875rem',
      small: '0.8rem',
      title: '1.25rem'
    },
    fontWeight: {
      cardTitle: 500,
      label: 400,
      button: 500
    },
    letterSpacing: {
      cardTitle: '-0.01em'
    }
  },

  // Spacing (same as light theme)
  spacing: {
    cardPadding: '1.25rem',
    cardPaddingMobile: '1rem',
    cardHeaderMargin: '1rem',
    cardHeaderPadding: '0.625rem',
    buttonMargin: '0.75rem',
    formGap: '1rem',
    gridGap: '1rem',
    // Scala numerica per gap/padding — sostituisce i valori ad-hoc sparsi nei componenti
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px'
  },

  // Altezza uniforme per input/select/button
  controlHeight: '32px',

  // Border radius (same as light theme)
  radius: {
    card: '12px',
    input: '6px',
    button: '6px',
    icon: '7px'
  },

  // Transitions (same as light theme)
  transitions: {
    default: 'all 0.2s ease',
    button: 'all 0.3s ease'
  },

  // Motion sidebar e micro-interazioni
  motion: {
    easeOut: 'cubic-bezier(.2,.8,.2,1)',
    sidebar: '260ms',
    fast: '120ms'
  }
}
